import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Space } from 'antd';
import { ButtonType } from 'antd/es/button';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { IMenuItem } from '../../shared/interfaces';

interface IDropdownOptionsProps {
  name?: string;
  items?: IMenuItem[] | any;
  size?: SizeType;
  type?: ButtonType;
}

export const DropdownOptions: React.FC<IDropdownOptionsProps> = ({
  name = 'Opções',
  items,
  size = 'small',
  type = 'primary',
}) => {
  const normalizedItems = (items || []).filter(Boolean);

  if (!normalizedItems.length) {
    return null;
  }

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: normalizedItems,
      }}
    >
      <Button size={size} type={type}>
        <Space>
          {name}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};
